'use strict';

var btnVideoPlay = document.querySelectorAll('.video_section .box_img');

if (btnVideoPlay.length > 0) {
    handleClickOnVideo(btnVideoPlay);
}

function showVideo(video) {
    video.classList.add('show');
    video.play();
}

function handleClickOnVideo(elementsClick) {
    elementsClick.forEach(function (item) {
        item.addEventListener('click', function () {
            showVideo(item.nextElementSibling);
        });
    });
}